import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { setUser } from "../store/authSlice";

/**
 * Fetches all admins from Firestore
 * @returns {Promise<Array>} Array of admin documents
 */
export const fetchAdminByEmail = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "admins"));
    return querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
  } catch (error) {
    console.error("Error fetching admins:", error);
    throw error;
  }
};

/**
 * Handles Route Partner Admin authentication
 * Sets up real-time listener for route partner data
 * @param {Object} user - Firebase user object
 * @param {Object} userWithRole - Admin user data with role
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Function} Unsubscribe function for the listener
 */
export const handleRoutePartnerAdmin = (user, userWithRole, dispatch) => {
  try {
    const routePartnersRef = collection(db, "routePartners");
    const q = query(
      routePartnersRef,
      where("isDeleted", "==", false),
      where("isRoutePartner", "==", true),
      where("emailId", "==", user?.email)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const routePartners = [];
        snapshot.forEach((doc) => {
          routePartners.push({ ...doc.data(), id: doc.id });
        });
        console.log(routePartners, "obj for routepartner role");

        dispatch(
          setUser({
            ...user,
            ...userWithRole,
          })
        );
      },
      (error) => {
        console.error("Error in route partner snapshot:", error);
      }
    );

    return unsubscribe;
  } catch (error) {
    console.error("Error setting up route partner listener:", error);
    throw error;
  }
};

/**
 * Handles regular admin authentication (non-Route Partner Admin)
 * @param {Object} user - Firebase user object
 * @param {Object} userWithRole - Admin user data with role
 * @param {Function} dispatch - Redux dispatch function
 */
export const handleRegularAdmin = (user, userWithRole, dispatch) => {
  dispatch(setUser({ ...user, ...userWithRole }));
};

